import axiosPost from "./axiosPost";

export const RNHNivelIns = async (credentials, data) => {
    const body = {
        service: "RNHNivelIns",
        params: {
            rnhNivelCod: data?.cod || null,
            rnhNivelNombre: data?.name || null
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
